export default "__VITE_ASSET__D$J3e5Vy__"